import httpClient from '../utils/httpClient';
import { API_ENDPOINTS } from '../config/api';

export const contactService = {
  // Submit contact form
  async submitContact(contactData) {
    const response = await httpClient.post(API_ENDPOINTS.CONTACT.SUBMIT, {
      name: contactData.name,
      email: contactData.email,
      phone: contactData.phone || '',
      subject: contactData.subject || 'General Inquiry',
      message: contactData.message
    });

    return response;
  }
};

export default contactService;